export var VisserModule;
(function (VisserModule) {
    VisserModule[VisserModule["Werkorder"] = 1] = "Werkorder";
    VisserModule[VisserModule["Klanten"] = 2] = "Klanten";
    VisserModule[VisserModule["WP_Planning"] = 3] = "WP_Planning";
    VisserModule[VisserModule["Leveranciers"] = 4] = "Leveranciers";
    VisserModule[VisserModule["Artikelen"] = 5] = "Artikelen";
    VisserModule[VisserModule["Offertes"] = 6] = "Offertes";
    VisserModule[VisserModule["Facturen"] = 7] = "Facturen";
    VisserModule[VisserModule["Bestellingen"] = 8] = "Bestellingen";
    VisserModule[VisserModule["Inkoopfacturen"] = 9] = "Inkoopfacturen";
    VisserModule[VisserModule["Documnentatie"] = 10] = "Documnentatie";
    VisserModule[VisserModule["Beheer"] = 11] = "Beheer";
})(VisserModule || (VisserModule = {}));
